class NewsletterPopup extends HTMLElement {
    connectedCallback() {
        this.timeToShow = parseInt(this.getAttribute('data-delay'));
        this.expiresDate = this.getAttribute('data-expire');

        this.triggerBtn = document.getElementById('halo-newsletter-trigger');
        if (this.triggerBtn) {
            this.triggerBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                document.body.classList.add('newsletter-show');
                setTimeout(() => {
                    document.body.classList.add('show-newsletter-image');
                }, 700);
            });
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        const closeBtn = this.querySelector('[data-close-newsletter-popup]');
        if (closeBtn) {
            closeBtn.addEventListener('click', this.setClosePopup.bind(this));
        }

        const form = this.querySelector('#ContactPopupModal') ||
                     this.querySelector('#ContactPopup') ||
                     this.querySelector('form.newsletter-form');
        if (form) {
            // Intercept submit event (fired when user clicks submit with no captcha, or captcha already done)
            form.addEventListener('submit', this.handleFormSubmit.bind(this));

            // Override form.submit() to intercept hCaptcha callback — hCaptcha calls
            // form.submit() directly after solving, which bypasses the submit event listener
            const self = this;
            form.submit = function () {
                self.doAjaxSubmit(form);
            };
        } else {
    
        }

        const dismissLabel = this.querySelector('label[for="dismiss"]');
        if (dismissLabel) {
            dismissLabel.addEventListener('click', this.setClosePopup.bind(this));
        }

        if (this.classList.contains('style-2')) {
            const copyButton = this.querySelector('.button-code--copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    const inputField = this.querySelector('.code__input .field__input');
                    const tooltip = copyButton.querySelector('.tooltip');
                    navigator.clipboard.writeText(inputField.value).then(() => {
                        tooltip.textContent = tooltip.dataset.success_message;
                    });
                });
            }

            $('.halo-newsletter-popup.style-2 .products-grid:has(.product:nth-child(3))')?.slick({
                infinite: true,
                arrows: true,
                dots: false,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                slidesToShow: 2,
                slidesToScroll: 2,
                rtl: window.rtl_slick
            });
        }
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const form = e.currentTarget;
        const hasCaptchaField = form.querySelector('[name="g-recaptcha-response"], [name="h-captcha-response"]');
        const captchaCompleted = form.querySelector('[name="g-recaptcha-response"]')?.value ||
                                 form.querySelector('[name="h-captcha-response"]')?.value;

        if (hasCaptchaField && !captchaCompleted) {
            return;
        }

        this.doAjaxSubmit(form);
    }

    doAjaxSubmit(form) {
        const btn = form.querySelector('button[type="submit"]');

        if (btn && btn.dataset.submitting === 'true') {
            return;
        }

        if (btn) {
            btn.dataset.originalText = btn.innerHTML;
            btn.innerHTML = 'Subscribing...';
            btn.disabled = true;
            btn.dataset.submitting = 'true';
        }

        fetch(form.action, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(new FormData(form)),
            redirect: 'manual'
        })
        .then(response => {
            if (response.type === 'opaqueredirect' || response.status === 0) {
                this.showSuccessView();
                return;
            }
            return response.text().then(html => {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const errorEl = doc.querySelector('.errors li, .errors p, .form-message--error');
                const errorText = errorEl ? errorEl.textContent.trim() : '';
                if (errorText) {
                    this.showErrorView(errorText);
                    if (btn) {
                        btn.innerHTML = btn.dataset.originalText || 'Subscribe';
                        btn.disabled = false;
                        delete btn.dataset.submitting;
                    }
                } else {
                    this.showSuccessView();
                }
            });
        })
        .catch(err => {
            console.error('[popup] fetch error:', err);
            if (btn) {
                btn.innerHTML = btn.dataset.originalText || 'Subscribe';
                btn.disabled = false;
                delete btn.dataset.submitting;
            }
        });
    }

    showErrorView(message) {
        const innerContainer = this.querySelector('.halo-popup-inner');
        if (innerContainer) {
            const form = this.querySelector('#ContactPopupModal') || this.querySelector('#ContactPopup');
            const btn = form?.querySelector('button[type="submit"]');
            if (btn) {
                btn.innerHTML = 'Subscribe';
                btn.disabled = false;
            }

            let errorDiv = this.querySelector('.subscription-error');
            if (!errorDiv) {
                errorDiv = document.createElement('div');
                errorDiv.className = 'subscription-error';
                errorDiv.style.cssText = 'color: #d9534f; background: #f2dede; border: 1px solid #d9534f; padding: 10px; margin-bottom: 15px; border-radius: 4px; font-size: 14px;';
                const popupContent = this.querySelector('.halo-popup-content');
                if (popupContent) {
                    popupContent.insertBefore(errorDiv, popupContent.firstChild);
                }
            }
            errorDiv.textContent = message;
        }
    }

    showSuccessView() {
        const innerContainer = this.querySelector('.halo-popup-inner');
        if (innerContainer) {
            innerContainer.innerHTML = `
                <div class="custom-upsell-wrapper halo-popup-inner">
                    <div class="halo-popup-header">
                        <h3 class="newsletter-popup-title text-center">
                            Thanks for Your<br>
                            <span>Subscription!</span>
                        </h3>
                    </div>
                    <div class="halo-popup-content">
                        <div class="custom-upsell-buy">
                            <div class="quantity__container">
                                <button type="button" name="minus" class="minus btn-quantity" onclick="changeUpsellQty(-1)">
                                    <span class="visually-hidden">&minus;</span>
                                </button>
                                <input type="number" id="upsell-qty" name="quantity" value="1" min="1" inputmode="numeric" pattern="[0-9]*" class="form-input quantity__input">
                                <button type="button" name="plus" class="plus btn-quantity" onclick="changeUpsellQty(1)">
                                    <span class="visually-hidden">&#43;</span>
                                </button>
                            </div>
                            <button type="button" onclick="buyNowVIP(this)" class="button gradient-bg gradient-button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 8px;">
                                    <circle cx="9" cy="21" r="1"></circle>
                                    <circle cx="20" cy="21" r="1"></circle>
                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                                </svg>
                                Pay Deposit
                            </button>
                        </div>
                        <button type="button" class="button" onclick="document.querySelector('.halo-popup-close').click()" style="color: #ff6600; border: 1px solid #ff6600; border-radius: 4px; width: 100%; height: 48px; font-weight: 500; font-size: 15px; cursor: pointer; transition: background 0.3s; margin-top: 15px;">
                            Continue Browsing
                        </button>
                    </div>
                </div>
            `;
        }
        document.body.classList.add('newsletter-show');
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
    }
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') { c = c.substring(1); }
            if (c.indexOf(name) === 0) { return c.substring(name.length, c.length); }
        }
        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup() {
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);
    }

    onBodyClickEvent(event) {
        if (
            (!this.contains(event.target)) &&
            ($(event.target).closest('[data-open-newsletter-popup]').length === 0) &&
            document.querySelector('body').classList.contains('newsletter-show')
        ) {
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    connectedCallback() {
        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close() {
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
